import { PatchEdgePayload } from '../../../../../models/edge/patch-edge-payload.model';
import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { IEdgeModel, ISourceTargetMappingModel } from '../../../../../models/blueprint/blueprint-edge.model';
import { IBluePrintModel } from '../../../../../models/blueprint/blueprint.model';
import { IKeyValueMapperModel, KeyValueMapperModel } from '../../../../../models/utility/key-value-mapper.model';
import { DashboardHelper } from '../../../../../services/dashboard.service';
import { Helper } from '../../../../../services/helper.service';
import { UiStateStore } from '../../../../../services/stores/ui-state.store';
import { BlueprintDataHelper } from '../../../../../services/helpers/blueprint-data.helper';
import { EdgeDisplayModel } from '../../../../../models/blueprint/blueprint-edge-display.model';
import { BluePrintAPIService } from '../../../../../services/api/blueprint.api.service';
import { BlueprintStore } from '../../../../../services/stores/blueprint.store';
import { GlobalSettingStore } from '../../../../../services/stores/global-setting.store';
import { AlertService } from '../../../../../services/alert.service';
import { UserService } from '../../../../../services/user.service';
import { PermissionService } from '../../../../../services/permission.service';

@Component({
  selector: 'app-blueprint-edge-property',
  templateUrl: './blueprint-edge-property.component.html',
  styleUrls: ['./blueprint-edge-property.component.css'],
  standalone: false,
})
export class BlueprintEdgePropertyComponent implements AfterViewInit, OnDestroy {
  selectedBluePrintEdge: IEdgeModel = {} as IEdgeModel;
  selectedBluePrintEdgeOldVal: IEdgeModel = {} as IEdgeModel;
  selectedBluePrint: IBluePrintModel = {} as IBluePrintModel;
  selectedSource: string = '';
  selectedTargets: string[] = [];
  availableSources: Array<IKeyValueMapperModel> = [];
  availableTargets: Array<IKeyValueMapperModel> = [];
  previousSelectedTargets: string[] = [];
  oldName: string = '';
  public subscribers: any = {};
  @ViewChild('inputName') inputNameElement!: ElementRef;
  @ViewChild('myForm') myForm!: NgForm;
  blueprintRelationshipTypes: string[] = [];

  constructor(
    private dashboardHelper: DashboardHelper,
    private bluePrintService: BluePrintAPIService,
    private bluePrintStore: BlueprintStore,
    private helperService: Helper,
    private route: ActivatedRoute,
    private uiStateStore: UiStateStore,
    private cdr: ChangeDetectorRef,
    private bluePrintHelper: BlueprintDataHelper,
    private router: Router,
    private alertService: AlertService,
    private globalSettingStore: GlobalSettingStore,
    private userService: UserService,
    private permissionService: PermissionService,
  ) {}

  public get isReadOnly(): boolean {
    if (this.permissionService.isSysAdmin) {
      return false;
    }
    const blueprintOrgId = this.selectedBluePrint?.organizationId?.toLowerCase();
    const userOrgId = this.userService.user?.organizationId?.toLowerCase();
    if (!blueprintOrgId || !userOrgId) {
      // Unknown org on either side - fail closed (read-only) rather than treat two empty/missing
      // org ids as a match.
      return true;
    }
    return blueprintOrgId !== userOrgId;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.subscribers.bp = this.bluePrintStore.$selectedBluePrint.subscribe((bp) => {
        if (bp) {
          this.selectedBluePrint = bp;
          if (!this.bluePrintStore.selectedBluePrintField) {
            this.subscribers.params = this.route.params.subscribe((params) => {
              if (params['id']) {
                if (this.selectedBluePrint) {
                  const edge = this.selectedBluePrint.edges.find((edge) => edge.id === params['id']);
                  if (edge) this.bluePrintStore.selectedBluePrintEdge = edge;
                  this.dashboardHelper.setShowRightPanel(true);
                }
              }
            });
          }
        }
      });

      this.subscribers.relationshipTypes = this.globalSettingStore.$blueprintRelationshipTypes.subscribe((types) => {
        if (types) {
          this.blueprintRelationshipTypes = types;
          this.cdr.detectChanges();
        }
      });

      this.subscribers.selectedItemChanged = this.dashboardHelper.selectedItem.subscribe((result) => {
        if (this.selectedBluePrintEdge && this.selectedBluePrintEdge.id !== result) {
          if (this.myForm && this.myForm.form.dirty && this.myForm.form.valid) {
            this.myForm.form.markAsPristine();
            this.saveWork(false);
          }
        }
      });

      this.subscribers.rightPanelVisible = this.dashboardHelper.$showRightPanel.subscribe((panelVisibility) => {
        if (panelVisibility === false) {
          // If right side panel is closed without saving then reset to previous value
          if (this.selectedBluePrint && this.selectedBluePrintEdgeOldVal) {
            const oldEdge = this.selectedBluePrint.edges.find((e) => e.id === this.selectedBluePrintEdgeOldVal.id);
            if (oldEdge) this.selectedBluePrint.edges[this.selectedBluePrint.edges.indexOf(oldEdge)] = this.selectedBluePrintEdgeOldVal;
            if (this.myForm && this.myForm.form.dirty && this.myForm.form.valid) {
              this.myForm.form.markAsPristine();
              this.cdr.detectChanges();
            }
          }
        }
      });

      this.subscribers.selectedBluePrintEdge = this.bluePrintStore.$selectedBluePrintEdge.subscribe((result) => {
        if (result) {
          this.selectedBluePrintEdge = result;
          this.selectedBluePrintEdgeOldVal = this.helperService.getDeepCopy(result);
          this.oldName = this.selectedBluePrintEdge.name;
          if (this.selectedBluePrintEdge) {
            this.selectedSource = '';
            this.selectedTargets = [];
            this.availableSources = [];
            this.availableTargets = [];
            this.availableSources.push(new KeyValueMapperModel('all', 'All'));
            this.availableTargets.push(new KeyValueMapperModel('all', 'All'));
            this.selectedBluePrint.nodes.forEach((node) => {
              // Load all nodes as source and targets for mapping
              this.availableSources.push(new KeyValueMapperModel(node.id, node.name));
              this.availableTargets.push(new KeyValueMapperModel(node.id, node.name));
            });
            if (this.selectedBluePrintEdge.sourceTargetMapping) {
              for (const key of Object.keys(this.selectedBluePrintEdge.sourceTargetMapping)) {
                this.selectedSource = key; // load saved source
                this.selectedBluePrintEdge.sourceTargetMapping[key].forEach((element) => {
                  this.selectedTargets.push(element); // pouplate saved targets
                });
                this.previousSelectedTargets = [...this.selectedTargets];
              }
            }
            if (!this.selectedBluePrintEdge.edgeDisplay) {
              this.selectedBluePrintEdge.edgeDisplay = new EdgeDisplayModel('', '', '', '', '');
            }
            this.oldName = this.selectedBluePrintEdge.name;
            this.cdr.detectChanges();
          }
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.cdr.detach();

    if (this.subscribers) {
      if (this.subscribers.selectedBluePrintEdge) {
        this.subscribers.selectedBluePrintEdge.unsubscribe();
      }
      if (this.subscribers.bp) {
        this.subscribers.bp.unsubscribe();
      }
      if (this.subscribers.params) {
        this.subscribers.params.unsubscribe();
      }
      if (this.subscribers.rightPanelVisible) {
        this.subscribers.rightPanelVisible.unsubscribe();
      }
      if (this.subscribers.selectedItemChanged) {
        this.subscribers.selectedItemChanged.unsubscribe();
      }
      if (this.subscribers.relationshipTypes) {
        this.subscribers.relationshipTypes.unsubscribe();
      }
    }
  }

  public saveWork(updateResponse: boolean = true) {
    if (this.isReadOnly) {
      return;
    }
    this.bluePrintHelper.validateName(this.oldName, 'edge');

    if (!this.selectedSource) {
      this.alertService.showWarningMessage('Please select source item');
      return;
    }
    if (this.selectedTargets.length === 0) {
      this.alertService.showWarningMessage('Please select at least one target item');
      return;
    }
    if (!this.selectedBluePrintEdge.relationshipType) {
      this.alertService.showWarningMessage('Please select relationship type');
      return;
    }
    if (this.selectedBluePrintEdge.sourceTargetMapping !== null && this.selectedTargets.length > 0) {
      for (const key of Object.keys(this.selectedBluePrintEdge.sourceTargetMapping)) {
        delete this.selectedBluePrintEdge.sourceTargetMapping[key]; // delete the existing mapping
        break;
      }
    }
    const dictionary: ISourceTargetMappingModel = {} as ISourceTargetMappingModel;

    dictionary[this.selectedSource] = this.selectedTargets; // #todo order needs to be worked
    this.selectedBluePrintEdge.isVisible = true;
    this.selectedBluePrintEdge.sourceTargetMapping = dictionary;
    // Dispatching the save clears dirty: the deselect auto-save (selectedItem subscription)
    // fires on a dirty form and would otherwise re-send this same patch, writing a second
    // identical 'blueprint modified' activity log entry (ZOO-10065).
    this.myForm?.form.markAsPristine();
    this.uiStateStore.startBackendAction('Saving edge...');

    // const patchPayload: PatchEdgePayload = new PatchEdgePayload();
    // patchPayload.bluePrintId = this.selectedBluePrint.id;
    // patchPayload.edge = this.selectedBluePrintEdge;
    // patchPayload.updateResponse = updateResponse;
    // this.selectedBluePrintEdgeOldVal = this.selectedBluePrintEdge;
    this.bluePrintStore.patchEdge(this.selectedBluePrintEdge).subscribe((result) => {
      this.uiStateStore.endBackendAction('Edge saved!');
      this.cdr.detectChanges();
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: this.selectedBluePrintEdge.id,
        name: this.selectedBluePrintEdge.name,
      });
    });
    // this.uiHelper.closeRightPanel(this.router);
  }

  public selectName() {
    if (
      this.inputNameElement &&
      this.inputNameElement.nativeElement &&
      this.inputNameElement.nativeElement.value &&
      this.inputNameElement.nativeElement.value.toLowerCase().indexOf('edge type'.toLowerCase()) === 0
    ) {
      this.inputNameElement.nativeElement.select();
    }
  }

  public targetSelectionChanged() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedTargets.length > 1 && this.selectedTargets.includes('all')) {
      const wasAllSelected = this.previousSelectedTargets.includes('all');
      if (wasAllSelected) {
        // "all" was already selected, so a new item was added, remove "all"
        this.selectedTargets = this.selectedTargets.filter((t) => t !== 'all');
      } else {
        // "all" was just selected, remove everything else
        this.selectedTargets = ['all'];
      }
    }
    this.previousSelectedTargets = [...this.selectedTargets];
  }

  public sourceSelectionChanged() {
    if (this.isReadOnly) {
      return;
    }
    this.availableTargets = []; // Reset the targets when selection changed
    this.availableTargets.push(new KeyValueMapperModel('all', 'All'));
    this.selectedBluePrint.nodes.forEach((node) => {
      this.availableTargets.push(new KeyValueMapperModel(node.id, node.name));
    });

    // remove selected source from available targets
    // const matchedTarget = this.availableTargets.find(node => node.key === this.selectedSource);
    // if (matchedTarget !== undefined) {
    //   this.availableTargets.splice(this.availableTargets.indexOf(matchedTarget), 1);
    // }

    // remove selected source from already selected targets
    if (this.selectedSource !== 'all') {
      const matchedSelectedTarget = this.selectedTargets.find((node) => node === this.selectedSource);
      if (matchedSelectedTarget !== undefined) {
        this.selectedTargets.splice(this.selectedTargets.indexOf(matchedSelectedTarget), 1);
      }
    }
  }

  public onChange() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintEdge.name === '') {
      return;
    }

    this.dashboardHelper.setModifiedPropertyItem({
      id: this.selectedBluePrintEdge.id,
      name: this.selectedBluePrintEdge.name,
    });
  }

  public onNameBlur() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintEdge.name === '') {
      this.selectedBluePrintEdge.name = this.oldName; // revert to old name
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: this.selectedBluePrintEdge.id,
        name: this.selectedBluePrintEdge.name,
      });
    } else {
      this.bluePrintHelper.validateName(this.oldName, 'edge');
      this.oldName = this.selectedBluePrintEdge.name;
    }
  }
}
